import React from "react";
import { Fade } from "react-awesome-reveal";
import Lottie from "react-lottie";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import animationData from "lotties/heart.json";
import QueryChecker from "utils/queryChecker";

const HeartScreen = () => {
  let navigate = useNavigate();
  const { data } = useSelector((store) => store.auth);

  // lottie animations
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

    const withQuery = QueryChecker(["promo","email","sId"]);

  return (
    <div className="step_card_body">
      <Fade direction="up" triggerOnce  duration={1400}>
        <Lottie
          options={defaultOptions}
          height={200}
          width={230}
          eventListeners={[
            {
              eventName: "complete",
              callback: () => navigate("/myAccount/welcome"+withQuery),
            },
          ]}
        />
      </Fade>
      <Fade direction="up" triggerOnce delay={1100} duration={1500}>
        <h3>
          Building your customized <br /> MamaZen plan, {data?.firstName}!
        </h3>
      </Fade>
      <br />
    </div>
  );
};

export default HeartScreen;
